import { useTranslation } from "@coworker/locales";
import { useMemo } from "react";
import LinkbarLoading from "../../../shared/components/Linkbar/LinkbarLoading";
import Linkbar from "../../../shared/components/Linkbar/Linkbar";

export const ItemsViewLinkbar = ({
  refillAreaName,
}: {
  refillAreaName: string;
}) => {
  const { t } = useTranslation();

  return useMemo(() => {
    if (!refillAreaName.length) {
      return <LinkbarLoading />;
    }
    return (
      <Linkbar
        items={[
          {
            label: t("refillAreasString"),
            to: `/multi-order-addons`,
          },
        ]}
        currentLabel={refillAreaName}
        currentAsH1
      />
    );
  }, [refillAreaName, t]);
};
